import React, { useState, useEffect } from 'react';
import { busApi } from '../../services/api/busApi';
import { IconClose } from '../../components/ui/icons';

function PartidasParada({ stopId, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!stopId) return;

    const fetchDepartures = async () => {
      setLoading(true);
      setData(null);
      try {
        const response = await busApi.getStopDepartures(stopId);
        setData(response.data);
      } catch (error) {
        // erro silencioso — a UI já trata data === null
      } finally {
        setLoading(false);
      }
    };

    fetchDepartures();
  }, [stopId]);

  return (
    <div className="partidas-parada-container">
      <button onClick={onClose} className="close-button" aria-label="Fechar">
        <IconClose size={20} aria-hidden="true" />
      </button>

      {loading && <p>Carregando próximos ônibus...</p>}

      {data && (
        <div>
          <h4>Horários programados em:</h4>
          {/* GTFS: era data.stops[0]?.name — renomeado para data.stop?.name (objeto único) */}
          <p className="stop-name">{data.stop?.name || `Parada ID: ${stopId}`}</p>
          <ul className="departures-list">
            {/* GTFS: era data.trips[] — renomeado para data.departures[] (array plano) */}
            {data.departures?.length > 0 ? data.departures.map((dep, index) => (
              <li key={`${dep.tripId}-${index}`}>
                <div className="trip-info">
                  {/* GTFS: era trip.color/trip.shortName — agora dep.routeColor/dep.routeShortName */}
                  <span
                    className="linha-badge"
                    style={{ borderColor: dep.routeColor, color: dep.routeColor }}
                  >
                    {dep.routeShortName}
                  </span>
                  <span className="headsign">Sentido: {dep.headsign}</span>
                </div>
                <div className="time-info">
                  {/* GTFS: era trip.departures[0]?.time — agora dep.departureTime "HH:MM:SS" */}
                  Horário previsto: <strong>{dep.departureTime?.substring(0, 5)}</strong>
                </div>
              </li>
            )) : <p>Nenhum ônibus previsto no momento.</p>}
          </ul>
        </div>
      )}
    </div>
  );
}

export default PartidasParada;